import React from 'react'
import { useNavigate } from 'react-router-dom'

import cn from 'classnames'

import { CustomButton, Icon } from 'src/components/ui'
import { useChangeBackground } from 'src/hooks/useChangeBackground'

import styles from './StatusPromoPage.module.scss'

interface Props {
  status: 'confirmation' | 'error'
  className?: string
}

const StatusPromoPage: React.FC<Props> = ({ status, className }) => {
  const navigate = useNavigate()
  useChangeBackground(styles.background)

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.container_header}>
        <Icon name={status === 'confirmation' ? 'confirmation_light' : 'error_light'} />

        <h1>{status === 'confirmation' ? 'Промокод застосовано!' : 'Промокод не дійсний'}</h1>
        <p>
          {status === 'confirmation'
            ? 'Ваш подарунок складає 100 страсів.'
            : 'Промокод недійсний або термін його дії закінчився. Спробуйте інший.'}
        </p>
      </div>

      <div className={styles.container_tabs}>
        <CustomButton
          onClick={() => navigate(status === 'confirmation' ? '/menu/promo' : '')}
          variant='outlined'
          color='violet'
        >
          {status === 'confirmation' ? 'Переглянути банки' : 'Спробувати ще раз'}
        </CustomButton>

        <CustomButton onClick={() => navigate('/')} variant='contained' color='violet'>
          На головну
        </CustomButton>
      </div>
    </div>
  )
}

export default StatusPromoPage
